import {Component, ViewEncapsulation} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Store} from '@ngrx/store';
import {map, Observable} from 'rxjs';
import * as  translationActions from '../../../../../translation.actions';
import {FilterDocumentStatusesEnum} from '../../dto/filter-document-statuses.enum';
import {DocumentListingFacade} from '../../store/document-listing.facade';

@Component({
  selector: 'app-filter-by-status',
  templateUrl: './filter-by-status.component.html',
  styleUrl: './filter-by-status.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FilterByStatusComponent {
    filterByStatus$:Observable<FilterDocumentStatusesEnum | null> = this._documentListingFacade.filterByStatus$;
    statusesList$  = this._store.select(translationActions.selectedTranslationChanged)
        .pipe(map(()=>{
            return [
                {name:this._translationService.translate('Document - listview - filters - All') , value: ''},
                {name:this._translationService.translate('Document - listview - filters - status - Pending') , value: FilterDocumentStatusesEnum.Pending},
                {name:this._translationService.translate('Document - listview - filters - status - Accepted') , value: FilterDocumentStatusesEnum.Accepted},
                {name:this._translationService.translate('Document - listview - filters - status - Lost'),  value: FilterDocumentStatusesEnum.Lost},
                {name:this._translationService.translate('Document - listview - filters - status - Draft') , value: FilterDocumentStatusesEnum.Draft}]
        }));

    constructor(
        private _documentListingFacade: DocumentListingFacade,
        private _store:Store,
        private _translationService: TranslocoService
        ) {
    }

    // onStatusSelected(status: FilterDocumentStatusesEnum) {
    //     this._documentListingFacade.filterByStatus(status);
    // }



    selectStatusFilter($event){
      this._documentListingFacade.filterByStatus($event?.value);
    }
}
